import React, { useState } from "react";
import {
  ExploreBody,
  Footer,
  Header,
  Hero,
  SampleProjects,
  HomepageServices,
  Loader,
  Vision,
} from "../components";


const Homepage = () => {
  // Simulating loading state and page transition with a timer e.g 3seconds
  const [isLoading, setIsLoading] = useState(true);

  useState(() => {
    const timer = setTimeout(() => {
      setIsLoading(false); // Set loading to false after 2 seconds
    }, 2000);

    return () => clearTimeout(timer); // Cleanup the timer on component unmount
  }, []);

  return (
    <>
      {isLoading ? (
        <Loader />
      ) : (
        <div className="bg-[#F7F8F9]">
          <div
              style={{
                  background: 'linear-gradient(140deg, rgb(247,248,249) 50%, #29313F 50%)',
                }}
          >
            <Header />
            <Hero />
          </div>
          <Vision />
          <HomepageServices />
          <ExploreBody />
          <SampleProjects />
          <Footer />
        </div>
      )}
    </>
  );
};

export default Homepage;
